module.exports = __webpack_public_path__ + "static/img/SearchDetailWork1.1f1ff37.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailWork1.png
// module id = 777
// module chunks = 0